var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "header__nav" };
const _hoisted_2 = { class: "logo-menu" };
const _hoisted_3 = { class: "header__logo" };
const _hoisted_4 = { href: "/" };
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
import { computed, getCurrentInstance, onMounted, ref, watch, nextTick, } from "vue";
import headerLogoFullWidthUrl from "../../../assets/extole-logo.png";
import headerLogoCollapsedUrl from "../../../assets/extole-logomark.svg";
import Session from "js/Session";
import MainNavigation from "./v-components/MainNavigation.vue";
import ClientSupportInfo from "./v-components/ClientSupportInfo.vue";
import AccountContainer from "./v-components/AccountContainer.vue";
import { useExtoleNavbarToggle } from "./composables";
import { useWindowSize } from "@vueuse/core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExtoleNavigation',
    setup(__props) {
        const session = Session.getInstance();
        const clients = session.getClients();
        const isSuperUser = session.isSuperUser();
        const isUserSupportUser = session.isUserSupportUser();
        const isSelfServiceUser = session.isSelfServiceUser();
        const hasClientSelector = isSuperUser || clients.length > 1;
        const { height } = useWindowSize();
        const { isNavbarCollapsed, toggleNavbar } = useExtoleNavbarToggle();
        const clientSupportInfo = ref(null);
        const clientSupportInfoHeight = ref(0);
        const isClientSupportInfoCollapsed = ref(false);
        const mainNavigation = ref(null);
        const computedHeight = computed(() => {
            var _a, _b;
            const accountHeight = hasClientSelector ? 255 : 200;
            return (height.value -
                accountHeight -
                (isClientSupportInfoCollapsed.value
                    ? clientSupportInfoHeight.value
                    : ((_b = (_a = clientSupportInfo.value) === null || _a === void 0 ? void 0 : _a.clientSupportInfoWrapper) === null || _b === void 0 ? void 0 : _b.offsetHeight) ||
                        0) +
                20);
        });
        const onToggleInfo = (height) => {
            isClientSupportInfoCollapsed.value = !isClientSupportInfoCollapsed.value;
            clientSupportInfoHeight.value = height || 0;
        };
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const instance = getCurrentInstance();
            const wrapperEl = (_b = (_a = instance === null || instance === void 0 ? void 0 : instance.proxy) === null || _a === void 0 ? void 0 : _a.$el) === null || _b === void 0 ? void 0 : _b.parentElement;
            yield nextTick();
            watch(isNavbarCollapsed, (collapsed) => {
                if (wrapperEl) {
                    wrapperEl.classList.toggle("collapsed", collapsed);
                }
            });
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("header", {
                class: _normalizeClass(["header header-side", {
                        collapsed: _unref(isNavbarCollapsed),
                    }]),
                "data-extole-header": ""
            }, [
                _createElementVNode("nav", _hoisted_1, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_unref(toggleNavbar) && _unref(toggleNavbar)(...args))),
                        class: "button button--medium button--tertiary button--circle button__toggle button__toggle--navbar"
                    }, [
                        _createElementVNode("i", {
                            class: _normalizeClass(["fa", {
                                    'fa-chevron-right': _unref(isNavbarCollapsed),
                                    'fa-chevron-left': !_unref(isNavbarCollapsed),
                                }])
                        }, null, 2 /* CLASS */)
                    ]),
                    _createElementVNode("ul", _hoisted_2, [
                        _createElementVNode("li", _hoisted_3, [
                            _createElementVNode("a", _hoisted_4, [
                                _createElementVNode("img", {
                                    src: _unref(headerLogoFullWidthUrl),
                                    class: "header__logo--fullwidth"
                                }, null, 8 /* PROPS */, _hoisted_5),
                                _createElementVNode("img", {
                                    src: _unref(headerLogoCollapsedUrl),
                                    class: "header__logo--collapsed"
                                }, null, 8 /* PROPS */, _hoisted_6)
                            ])
                        ])
                    ]),
                    _createVNode(MainNavigation, {
                        ref_key: "mainNavigation",
                        ref: mainNavigation,
                        hasClientSelector: _unref(hasClientSelector),
                        isUserSupportUser: _unref(isUserSupportUser),
                        isSelfServiceUser: _unref(isSelfServiceUser),
                        height: computedHeight.value,
                        style: _normalizeStyle(`height: ${computedHeight.value}px;`)
                    }, null, 8 /* PROPS */, ["hasClientSelector", "isUserSupportUser", "isSelfServiceUser", "height", "style"]),
                    _createVNode(ClientSupportInfo, {
                        ref_key: "clientSupportInfo",
                        ref: clientSupportInfo,
                        isUserSupportUser: _unref(isUserSupportUser),
                        isSelfServiceUser: _unref(isSelfServiceUser),
                        onToggleInfo: onToggleInfo
                    }, null, 8 /* PROPS */, ["isUserSupportUser", "isSelfServiceUser"]),
                    _createVNode(AccountContainer, { isNavbarCollapsed: _unref(isNavbarCollapsed) }, null, 8 /* PROPS */, ["isNavbarCollapsed"])
                ])
            ], 2 /* CLASS */));
        };
    }
});
